// Angular Velocity units with conversion factors to radian per second (rad/s)
export const velocityAngularUnits = [
  { id: 'radian-per-second', name: 'Radian/Second', symbol: 'rad/s', plural: 'Radians/Second', factor: 1 },
  { id: 'radian-per-day', name: 'Radian/Day', symbol: 'rad/d', plural: 'Radians/Day', factor: 1.157407407e-5 },
  { id: 'radian-per-hour', name: 'Radian/Hour', symbol: 'rad/h', plural: 'Radians/Hour', factor: 0.000277777778 },
  { id: 'radian-per-minute', name: 'Radian/Minute', symbol: 'rad/min', plural: 'Radians/Minute', factor: 0.01666666667 },
  { id: 'degree-per-second', name: 'Degree/Second', symbol: '°/s', plural: 'Degrees/Second', factor: 0.01745329252 },
  { id: 'degree-per-day', name: 'Degree/Day', symbol: '°/d', plural: 'Degrees/Day', factor: 2.020127456e-7 },
  { id: 'degree-per-hour', name: 'Degree/Hour', symbol: '°/h', plural: 'Degrees/Hour', factor: 4.848305556e-6 },
  { id: 'degree-per-minute', name: 'Degree/Minute', symbol: '°/min', plural: 'Degrees/Minute', factor: 0.0002908882087 },
  { id: 'revolution-per-second', name: 'Revolution/Second', symbol: 'rev/s', plural: 'Revolutions/Second', factor: 6.283185307 },
  { id: 'revolution-per-minute', name: 'Revolution/Minute', symbol: 'rpm', plural: 'Revolutions/Minute', factor: 0.1047197551 },
  { id: 'revolution-per-hour', name: 'Revolution/Hour', symbol: 'rev/h', plural: 'Revolutions/Hour', factor: 0.001745329252 },
  { id: 'revolution-per-day', name: 'Revolution/Day', symbol: 'rev/d', plural: 'Revolutions/Day', factor: 7.272205217e-5 },
];

export const popularVelocityAngularConversions = [
  { from: 'radian-per-second', to: 'degree-per-second' },
  { from: 'degree-per-second', to: 'radian-per-second' },
  { from: 'revolution-per-minute', to: 'radian-per-second' },
  { from: 'radian-per-second', to: 'revolution-per-minute' },
  { from: 'revolution-per-second', to: 'revolution-per-minute' },
  { from: 'revolution-per-minute', to: 'degree-per-second' },
  { from: 'degree-per-minute', to: 'radian-per-second' },
  { from: 'radian-per-minute', to: 'degree-per-minute' },
];

export const getUnitById = (id) => velocityAngularUnits.find(unit => unit.id === id);

export const convertVelocityAngular = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert ${fromUnit.plural.toLowerCase()} (${fromUnit.symbol}) to ${toUnit.plural.toLowerCase()} (${toUnit.symbol}) and learn the conversion formula.`;
};
